import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { TimeTrackingConfiguration } from './timeTrackingConfigurationTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class TimeTrackingConfigurationRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.TimeTrackingConfiguration,
  AppEntityManagerEntityTypesByEntityName
> {
  public getByUserGroupId(
    userGroupId: string
  ): Array<TimeTrackingConfiguration> {
    return this.getAll().filter(
      (config) => config.ownerUserGroupId === userGroupId
    );
  }
}
